import { render } from "./DocumentsView.vue?vue&type=template&id=3634602d&ts=true"
import script from "./DocumentsView.vue?vue&type=script&lang=ts"
export * from "./DocumentsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__